export default __webpack_public_path__ + "static/media/profession.e56097c4.svg";